module.exports = __webpack_public_path__ + "static/Hospitality-hero-6632b34e13185c657ce1ec237fcd3006.png";